exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".feature-component .feature{font-size:32px;font-weight:700;padding:15px 20px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?outputStyle=expanded!./src/develop/Feature.scss
// module id = 611
// module chunks = 0